var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16602 3.33073C5.94435 3.33073 3.33268 5.9424 3.33268 9.16406C3.33268 12.3857 5.94435 14.9974 9.16602 14.9974C12.3877 14.9974 14.9993 12.3857 14.9993 9.16406C14.9993 5.9424 12.3877 3.33073 9.16602 3.33073ZM1.66602 9.16406C1.66602 5.02193 5.02388 1.66406 9.16602 1.66406C13.3082 1.66406 16.666 5.02193 16.666 9.16406C16.666 13.3062 13.3082 16.6641 9.16602 16.6641C5.02388 16.6641 1.66602 13.3062 1.66602 9.16406Z",
    fill: "#1D1F2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2851 13.2831C13.6105 12.9577 14.1382 12.9577 14.4636 13.2831L18.0886 16.9081C18.414 17.2336 18.414 17.7612 18.0886 18.0867C17.7632 18.4121 17.2355 18.4121 16.9101 18.0867L13.2851 14.4617C12.9597 14.1362 12.9597 13.6086 13.2851 13.2831Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3f9cce809688bd3f9480fa1dbd0caedc.svg";
export { ForwardRef as ReactComponent };